import { Component, Directive, ElementRef, Injector } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

import { default as componentAjs } from './custom.component.ajs';

@Directive({
  selector: 'cng-hypervision-skill-custom-upgrade',
})
export class HypervisionSkillCustomUpgradeComponent extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super(componentAjs, elementRef, injector);
  }
}

@Component({
  selector: 'cng-hypervision-skill-custom',
  template: '<cng-hypervision-skill-custom-upgrade></cng-hypervision-skill-custom-upgrade>',
})
export class HypervisionSkillCustomComponent {}
